import { render, staticRenderFns } from "./MultiRangeLabValueField.vue?vue&type=template&id=4f73e3c4&scoped=true"
import script from "./MultiRangeLabValueField.vue?vue&type=script&lang=ts"
export * from "./MultiRangeLabValueField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f73e3c4",
  null
  
)

export default component.exports